import zones from "full-countries-cities";
import { flag } from "country-emoji";
import firebase from "@/firebase";

const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

const localStorageParse = (key, type, def) => {
  if (type === "Boolean") {
    if (localStorage.getItem(key) == null) {
      if (def != null) {
        return def;
      } else {
        return false;
      }
    }
    return localStorage.getItem(key) === "true" ? true : false;
  }
  if (type === "String") {
    if (localStorage.getItem(key) == null) {
      if (def != null) {
        return def;
      } else {
        return "";
      }
    }
    return localStorage.getItem(key);
  }
  if (type === "Number") {
    if (localStorage.getItem(key) == null) {
      if (def != null) {
        return def;
      } else {
        return 0;
      }
    }
    return +localStorage.getItem(key);
  }
  if (type === "ArrayString") {
    if (localStorage.getItem(key) == null) {
      if (def != null) {
        return def;
      } else {
        return [];
      }
    }
    return localStorage.getItem(key).split(",");
  }
  if (type === "Array") {
    if (localStorage.getItem(key) == null) {
      if (def != null) {
        return def;
      } else {
        return [];
      }
    }
    return JSON.parse(localStorage.getItem(key));
  }
  if (type === "Json") {
    if (localStorage.getItem(key) == null) {
      if (def != null) {
        return def;
      } else {
        return {};
      }
    }

    return JSON.parse(localStorage.getItem(key));
  }

  throw new Error("Type not found");
};

const n = zones.getCountryNames().map((c) => {
  const f = flag(c);
  return `${f != null ? f + " " : ""}${c}`;
});
const countryNames = [];
countryNames.push("🇪🇺 Europe");
countryNames.push("🌏 Asia");
countryNames.push("🌍 EMEA");
countryNames.push("🌎 LATAM");
countryNames.push("🗺️ Worldwide");
countryNames.push("🏡 Remote");
countryNames.push("🚀 Mars");
countryNames.push("🇺🇸 USA");
countryNames.push("🇺🇸 United States of America");
countryNames.push("🇺🇸 EEUU");
countryNames.push("🇬🇧 UK");

const arr = countryNames.concat(n);

const validURL = (str) => {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" +
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
      "((\\d{1,3}\\.){3}\\d{1,3}))" +
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
      "(\\?[;&a-z\\d%_.~+=-]*)?" +
      "(\\#[-a-z\\d_]*)?$",
    "i"
  );
  return !!pattern.test(str);
};

const getUrlFromPath = async (path) => {
  try {
    const ref = firebase.storage.ref().child(path);
    return await ref.getDownloadURL();
  } catch (error) {
    console.error(error);
  }
};

const uploadImage = async (imageBlob, path, name, extension) => {
  const metadata = {
    contentType: "image/png",
  };
  const imagePath = `images/${path}/${name}.${extension}`;
  const ref = firebase.storage.ref().child(imagePath);
  try {
    await ref.putString(imageBlob, "data_url", metadata);
  } catch (e) {
    console.error(e);
    return false;
  }
  return true;
};

export default {
  sleep,
  getUrlFromPath,
  uploadImage,
  isDev: process.env.NODE_ENV === "development",
  localStorageParse,
  countryNames: arr,
  validURL,
  getLocation: () => window.location.origin,
  shuffleArray,
};
